export { registerComponent as registerVideoComponent } from '../../components/builtin/Video/register'
export { default as Video } from '../../components/builtin/Video/Video'
